module.exports = __webpack_public_path__ + "static/img/1.2bdf267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/frede/1.jpg
// module id = JnP5
// module chunks = 0